import script from "./YoutubeInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./YoutubeInput.vue?vue&type=script&setup=true&lang=ts"

import "./YoutubeInput.vue?vue&type=style&index=0&id=0960aadc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0960aadc"]])

export default __exports__